import appSettings from "./app-settings";

export {
    appSettings
}
